//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "App",
  data() {
    return {
      startNumX: 0,
      endNumX: 0,
      startNumY: 0,
      endNumY: 0,
    }
  },
  mounted: function () {
    window.addEventListener(
      'hashchange',
      () => {
        const currentPath = window.location.hash.slice(1);
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      },
      false
    )
  },
  methods: {
  }
};

// window.onload = function () {
//   document.addEventListener("touchstart", function (event) {
//     if (event.touches.length > 1) {
//       event.preventDefault();
//     }
//   });
//   document.addEventListener("gesturestart", function (event) {
//     event.preventDefault();
//   });
// };



// WEBPACK FOOTER //
// ./src/App.vue